const initialState = {
  idIntegration: '',
  token: '',
  idHotel: '',
  hotelCode: '',
  hotelDetails: {},
};

const hotelDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_HOTEL_DETAIL':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default hotelDetailReducer;
